import { Collections } from '../../../firebase/firestore/collections';
import { CandidateRecruiterAction } from '../../../firebase/firestore/documents/candidateRecruiterAction';
import { useDocumentSnapshot } from '../../../firebase/firestore/hooks';

export const useFetchCandidateActions = (actionId: string): [CandidateRecruiterAction | undefined, boolean] => {
  return useDocumentSnapshot<CandidateRecruiterAction>(Collections.CANDIDATE_RECRUITER_ACTION, actionId, true, true);
};
